import { render, staticRenderFns } from "./childtaskAllocation.vue?vue&type=template&id=b3e77a4a&scoped=true"
import script from "./childtaskAllocation.vue?vue&type=script&lang=js"
export * from "./childtaskAllocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e77a4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3e77a4a')) {
      api.createRecord('b3e77a4a', component.options)
    } else {
      api.reload('b3e77a4a', component.options)
    }
    module.hot.accept("./childtaskAllocation.vue?vue&type=template&id=b3e77a4a&scoped=true", function () {
      api.rerender('b3e77a4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/compliancecso/childtask/components/childtaskAllocation.vue"
export default component.exports